module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resultsWrapper flexContainer fw-w full",
    attrs: {
      "id": "planoList"
    }
  }, [_vm._l((_vm.listPlano), function(item) {
    return _c('PlanoListItem', {
      key: item.id,
      attrs: {
        "item": item,
        "dense": _vm.type !== 'catalog'
      },
      on: {
        "openEditNameModal": _vm.showEditNameModal,
        "showDuplicateModal": _vm.showDuplicateModal,
        "changeStatusPlano": _vm.changeStatusPlano,
        "openPlano": _vm.openPlano,
        "modalComment": _vm.modalComment,
        "archivedPlano": _vm.archivedPlano,
        "version": _vm.version
      }
    })
  }), _vm._v(" "), (_vm.showModal) ? _c('duplicate', {
    attrs: {
      "show": _vm.showModal,
      "currentPlanoCampaign": _vm.currentPlanoCampaign,
      "currentPlanoZone": _vm.currentPlanoZone,
      "currentPlanoId": _vm.currentPlanoId,
      "currentPlanoName": _vm.currentPlanoName,
      "currentStandDesign": _vm.currentStandDesign
    },
    on: {
      "close": function($event) {
        _vm.showModal = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('editName', {
    attrs: {
      "show": _vm.showModalEditName,
      "currentPlanoId": _vm.currentPlanoId,
      "currentPlanoName": _vm.currentPlanoName
    },
    on: {
      "close": function($event) {
        _vm.showModalEditName = false;
      }
    }
  }), _vm._v(" "), (_vm.showModalComment) ? _c('Comment', {
    on: {
      "closeModal": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "action": _vm.dataAction
    }
  }), _vm._v(" "), (_vm.versionList) ? _c('modalPlanoVersion', {
    on: {
      "hideEditPlanoVersion": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0fe3bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/planoList.vue
// module id = 3008
// module chunks = 0